'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DISTANCE_UNITS = exports.DISTANCE_UNITS = {
  mi: 'mi',
  km: 'km'
};

var SYSTEMS = exports.SYSTEMS = {
  imperial: 'imperial',
  metric: 'metric'
};